export default "__VITE_ASSET__88e88e41__"